import { GetBindsResponse } from "@1games-ru/region-shared/dist/client/requests/account";
import { KeyboardBindType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { useEffect, useState } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { controlSettingsSelector } from "@/domains/settings/control/slice";

type GetBindsResponseValue = NonNullable<GetBindsResponse[keyof GetBindsResponse]>;

export default function useControlValues() {
  const controlSettings = useAppSelector(controlSettingsSelector);
  const [basicControls, setBasicControls] = useState<[number, GetBindsResponseValue][]>([]);
  const [vehicleControls, setVehicleControls] = useState<[number, GetBindsResponseValue][]>([]);
  const [conversationControls, setConversationControls] = useState<
    [number, GetBindsResponseValue][]
  >([]);

  useEffect(() => {
    const binds = Object.entries(controlSettings);
    const basicControlsArray: [number, GetBindsResponseValue][] = [];
    const vehicleControlsArray: [number, GetBindsResponseValue][] = [];
    const conversationControlsArray: [number, GetBindsResponseValue][] = [];

    binds.forEach(([key, value]) => {
      const keyNumber = Number(key);
      switch (keyNumber) {
        case KeyboardBindType.INTERACT:
        case KeyboardBindType.PHONE_OPEN_CLOSE:
        case KeyboardBindType.TABLET_OPEN_CLOSE:
        case KeyboardBindType.INVENTORY:
        case KeyboardBindType.MENU:
        case KeyboardBindType.SETTINGS:
        case KeyboardBindType.ANIMATION_MENU:
        case KeyboardBindType.STOP_ANIMATION:
        case KeyboardBindType.TOGGLE_HUD:
        case KeyboardBindType.HOLSTER_WEAPON:
        case KeyboardBindType.TOGGLE_HINTS:
        case KeyboardBindType.NAVIGATOR:
        case KeyboardBindType.REPORT_MENU:
        case KeyboardBindType.BODY_CAMERA:
        case KeyboardBindType.CROUCH:
        case KeyboardBindType.PRONE:
        case KeyboardBindType.QUICK_SLOT_1:
        case KeyboardBindType.QUICK_SLOT_2:
        case KeyboardBindType.QUICK_SLOT_3:
        case KeyboardBindType.QUICK_SLOT_4:
        case KeyboardBindType.QUICK_SLOT_5:
        case KeyboardBindType.QUICK_SLOT_6:
        case KeyboardBindType.MINIMAP_SIZE:
        case KeyboardBindType.SHOW_MOUSE:
          basicControlsArray.push([keyNumber, value]);
          break;

        case KeyboardBindType.ENTER_DRIVER:
        case KeyboardBindType.ENTER_PASSENGER:
        case KeyboardBindType.ENGINE_TOGGLE:
        case KeyboardBindType.VEHICLE_LOCK:
        case KeyboardBindType.SEAT_BELT:
        case KeyboardBindType.INDICATOR_LEFT:
        case KeyboardBindType.INDICATOR_RIGHT:
        case KeyboardBindType.INDICATOR_HAZARD:
        case KeyboardBindType.NITRO:
        case KeyboardBindType.CRUISE_CONTROL:
        case KeyboardBindType.HANDBRAKE:
        case KeyboardBindType.SPEED_LIMITER:
        case KeyboardBindType.VEHICLE_MENU:
        case KeyboardBindType.EMERGENCY_LIGHTS:
          vehicleControlsArray.push([keyNumber, value]);
          break;

        // 🎤 Общение и чат
        case KeyboardBindType.VOICE_CHAT:
        case KeyboardBindType.VOICE_MODE_SWITCH:
        case KeyboardBindType.RADIO_TALK:
        case KeyboardBindType.MEGAPHONE:
        case KeyboardBindType.VOICE_RELOAD:
        case KeyboardBindType.POINT:
        case KeyboardBindType.CHAT_OPEN:
        case KeyboardBindType.CHAT_CHANNEL_SWITCH:
        case KeyboardBindType.ACCEPT:
        case KeyboardBindType.DECLINE:
          conversationControlsArray.push([keyNumber, value]);
          break;

        default:
          console.warn(`Unmapped key bind type: ${keyNumber}`, value);
          break;
      }
    });

    setBasicControls(basicControlsArray);
    setVehicleControls(vehicleControlsArray);
    setConversationControls(conversationControlsArray);
  }, [controlSettings]);

  return { basicControls, vehicleControls, conversationControls };
}
